// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"664":"c1361d291f8a7ebba16d","825":"7df1d5e272075816451c"}[chunkId] + ".js";
};